<template>
    <base-layout :title="title">
        <template slot="header-right">
            <router-link class="right" tag="span" to="">交易记录</router-link>
        </template>
        <template slot="main">
            <div class="balance-info">
                <div class="rest-amount">￥{{pagingData[0].availableAmount}}</div>
                <div class="rest-amount-text">
                    <span>可用余额</span>
                </div>
                <div class="button-box">
                    <button class="left">绑定实体卡</button>
                    <button class="right">购卡</button>
                </div>
            </div>
            <div class="card-list-page">
                <ul class="card-header">
                    <li :class="{focus:cardState === 0}" @click="cardState=0">
                        <button>可使用({{pagingData[0].amount}})</button>
                    </li>
                    <li :class="{focus:cardState === 1}" @click="cardState=1">
                        <button>待领取({{pagingData[1].amount}})</button>
                    </li>
                    <li :class="{focus:cardState === 2}" @click="cardState=2">
                        <button>转增中({{pagingData[2].amount}})</button>
                    </li>
                </ul>
                <div class="card-list">
                    <tab :index="swithIndex" @change="swithChange">
                        <tab-item>
                            <scroller
                                    ref="scroller2"
                                    :noDataText="isRequest || pagingData[0].isLoading  || !pagingData[0].list.length ?'':noDataText"
                                    :on-refresh="refresh"
                                    :on-infinite="infinite"
                            >
                                <loading
                                        text="可使用的达美乐电子预付卡明细加载中..."
                                        v-if="pagingData[0].isLoading"
                                        :message="pagingData[0].errMsg"
                                />
                                <div v-else class="card-main">
                                    <div class="gap"></div>
                                    <div :key="info.no" v-for="info in pagingData[0].list" class="card-item">
                                        <card
                                                :cardNo="info.cardNo"
                                                :cardExpiredDate="info.cardExpiredDate"
                                                :cardName="info.cardName"
                                                :cardBalance="info.cardBalance"
                                        ></card>
                                    </div>
                                </div>
                            </scroller>
                        </tab-item>

                        <tab-item>
                            <scroller
                                    ref="scroller2"
                                    :noDataText="isRequest || pagingData[1].isLoading  || !pagingData[1].list.length ?'':noDataText"
                                    :on-refresh="refresh"
                                    :on-infinite="infinite"
                            >
                                <loading
                                        text="待领取的达美乐电子预付卡明细加载中..."
                                        v-if="pagingData[1].isLoading"
                                        :message="pagingData[1].errMsg"
                                />
                                <div v-else class="card-main">
                                    <div class="gap"></div>
                                    <div :key="info.no" v-for="info in pagingData[1].list" class="card-item">
                                        <card
                                                :cardNo="info.cardNo"
                                                :cardExpiredDate="info.cardExpiredDate"
                                                :cardName="info.cardName"
                                                :cardBalance="info.cardBalance"
                                        ></card>
                                    </div>
                                </div>
                            </scroller>
                        </tab-item>

                        <tab-item>
                            <scroller
                                    ref="scroller2"
                                    :noDataText="isRequest || pagingData[2].isLoading  || !pagingData[2].list.length ?'':noDataText"
                                    :on-refresh="refresh"
                                    :on-infinite="infinite"
                            >
                                <loading
                                        text="转增中的达美乐电子预付卡明细加载中..."
                                        v-if="pagingData[2].isLoading"
                                        :message="pagingData[2].errMsg"
                                />
                                <div v-else class="card-main">
                                    <div class="gap"></div>
                                    <div :key="info.no" v-for="info in pagingData[2].list" class="card-item">
                                        <card
                                                :cardNo="info.cardNo"
                                                :cardExpiredDate="info.cardExpiredDate"
                                                :cardName="info.cardName"
                                                :cardBalance="info.cardBalance"
                                        ></card>
                                    </div>
                                </div>
                            </scroller>
                        </tab-item>
                    </tab>
                </div>
            </div>
        </template>
    </base-layout>
</template>

<script>
	import {Toast} from "vant";
	import tab from "@components/comm/tab";
	import tabItem from "@components/comm/tabItem";
	import loading from "@components/comm/loading";
	import baseLayout from "@comm/view/layout/baseLayout";
	// 下拉刷新组件
	import scroller from "vue-scroller";
	import card from "@components/comm/card";
	// 用户存储
	import userStore from '@comm/store/user/userInfo.store.js'

	export default {
		name: 'myCardsList',
		components: {
			tab,
			tabItem,
			loading,
			baseLayout,
			scroller: scroller.Scroller,
			card
		},
		beforeRouteEnter(to, from, next) {
			next(userStore.getters.isLogin ? undefined : '/login')
		},
		created() {
			this.$pageLoad(this.request);
		},
		data() {
			const pageSize = 15;
			const pageNum = 1;

			return {
				// 页面标题
				title: "我的达美乐电子预付卡",
				cardState: 0,
				isRequest: false,
				// 滚动组件
				noDataText: "没有更多数据",
				// 分页数据 以订单状态为key
				pagingData: {
					0: {
						// 是否加载中
						isLoading: true,
						errMsg: "",
						// 页面大小
						pageSize: pageSize,
						// 当前页
						pageNo: pageNum,
						availableAmount: 0.00,
						amount: 0,
						// 数据容器
						list: [],
						moblie: "",
						isPager: "N"
					},
					1: {
						// 是否加载中
						isLoading: false,
						errMsg: "",
						pageSize: pageSize,
						pageNum: pageNum,
						availableAmount: 0.00,
						amount: 0,
						list: [
							{
								cardNo: "201901010011111111",
								amount: 100,
								validUntil: "20190909",
								balance: 10
							},
							{
								cardNo: "201901010011111111",
								amount: 200,
								validUntil: "20190909",
								balance: 50
							}
						]
					},
					2: {
						// 是否加载中
						isLoading: false,
						errMsg: "",
						pageSize: pageSize,
						pageNum: pageNum,
						availableAmount: 0.00,
						amount: 0,
						list: [
							{
								cardNo: "201901010011111111",
								amount: 200,
								validUntil: "20190909",
								balance: 10
							}
						]
					}
				}
			};
		},
		computed: {
			// 切换的索引
			swithIndex() {
				let swithIndex = 0;
				switch (this.cardState) {
					case 1:
						swithIndex = 1;
						break;
					case 2:
						swithIndex = 2;
						break;
				}
				return swithIndex;
			}
		},
		methods: {
			swithChange(event) {
				switch (event.activeIndex) {
					case 0:
						this.cardState = 0;
						break;
					case 1:
						this.cardState = 1;
						break;
					case 2:
						this.cardState = 2;
						break;
				}
				// 触发数据请求
				this.request();
			},
			// 达美乐电子预付卡列表数据请求
			request(action) {
				this.isRequest = true;
				return new Promise((resolve, reject) => {
					const state = this.cardState;
					// 对应的状态分页数据
					const pagingData = this.pagingData[state];
					// 检查请求
					switch (action) {
						// 下一页
						case "next":
							if (!pagingData.lastSize && pagingData.list.length) {
								pagingData.pageNum++;
							}
							break;
						// 刷新
						case "refresh":
							// 检查是否已经请求过数据
							if (pagingData.list.length && !pagingData.lastSize) {
								this.isRequest = false;
								return resolve();
							}
							break;
						// 刷新
						default:
							// 检查是否已经请求过
							if (pagingData.list.length && !action)
								return (this.isRequest = false);
					}

					if (pagingData.list.length) {
						// 数据请求loading遮盖层
						/*Toast.loading({
                                          mask: true,
                                          message: '加载中...',
                                          duration: 0,
                                      });*/
					} else {
						pagingData.isLoading = true;
					}

					// 达美乐电子预付卡列表数据请求
					this.$service("getPrePaidCards")
						.success(res => {
							Toast.clear();
							res.list = res.qryBindCardData.cardExtInfo || [];

							// 检查是否有遗留数据
							if (pagingData.lastSize) {
								pagingData.list.splice(-pagingData.lastSize, pagingData.lastSize);
							}
							// 添加数据
							pagingData.list.push(...res.list);
							pagingData.amount = res.amount,
								pagingData.availableAmount = res.qryBindCardData.availableAmount,

								pagingData.lastSize = res.list.length % pagingData.pageSize;

							if (pagingData.list.length) {
								pagingData.isLoading = false;
							} else {
								pagingData.errMsg = "暂无明细~";
							}
							resolve();
							this.$nextTick(() => {
								this.isRequest = false;
							});
						})
						.error(err => {
							// Toast(err);
							pagingData.errMsg = err;
							reject();
							// 下一页
							if (action == "next") {
								pagingData.pageNum--;
							}
							this.$nextTick(() => {
								this.isRequest = false;
							});
						})
						.send({
							// 接口中拼写为moblie
							moblie: userStore.getters.loginUser,
							isPager: 'N',
							pageNo: this.pageNo,
							pageSize: this.pageSize
						});
				});
			},
			// 下拉刷新
			refresh(done) {
				if (this.isRequest) return done(true);
				this.isRequest = true;
				this.request("refresh").then(
					() => {
						done();
					},
					() => {
						done();
					}
				);
			},
			// 无限加载回调
			infinite(done) {
				const state = this.cardState;
				// 对应的状态分页数据
				const pagingData = this.pagingData[state];
				if (this.isRequest || !pagingData.list.length) return done(true);
				this.isRequest = true;
				this.request("next").then(
					() => {
						done(true);
					},
					() => {
						done(true);
					}
				);
			}
		}
	};
</script>

<style lang="scss" scoped>
    @import "~@assets/style/app/var.scss";

    .card-list-page {
        height: 100%;
        display: flex;
        flex-direction: column;
        background-color: white;
    }

    /deep/ {
        .base-layout-header {
            box-shadow: none !important;
        }
        ._v-content {
            min-height: 100%;
        }
        .loading-container {
            min-height: 300px;
        }
    }

    .gap {
        // padding-top: 10px;
        background-color: $pageBg;
    }

    .card-info-main,
    .card-header li,
    .info-footer {
        background-color: white;
    }

    .balance-info {
        border-top: solid 1px #f3f3f3;
        padding-top: 10px;
        height: 120px;
        display: flex;
        flex-direction: column;
        align-items: center;
        .rest-amount {
            color: #f22c37;
            font-size: 24px;
            font-weight: 600;
        }
        .rest-amount-text {
            font-size: 10px;
        }
        .button-box {
            display: flex;
            justify-content: space-around;
            width: 200px;
            height: 32px;
            margin-top: 10px;
            .left {
                width: 90px;
                height: 30px;
                border-radius: 5px;
                border: 1px #f22c37 solid;
                background-color: #fff;
                color: #f22c37;
            }
            .right {
                width: 60px;
                height: 30px;
                border-radius: 5px;
                border: 1px #f22c37 solid;
                background-color: #f22c37;
                color: #fff;
                box-shadow: 0px 5px 10px 5px rgba(242, 44, 55, 0.15);
            }
        }
    }

    .card-header {
        display: flex;
        align-items: center;
        justify-content: space-around;
        border-bottom: solid 1px #f3f3f3;
        margin-top: 10px;
        li {
            width: (100% / 3);
            height: 40px;
            text-align: center;
            button {
                height: 30px;
                width: 90px;
                border-radius: 5px;
                background-color: #f6f9fc;
                color: #000;
                // border: 1px  #F6F9FC solid;
                border: 0px;
            }
            &.focus {
                button {
                    background-color: #f22c37;
                    color: #fff;
                    box-shadow: 0px 5px 10px 5px rgba(242, 44, 55, 0.15);
                }
            }
        }
    }

    .card-list {
        flex: 1;
        overflow: auto;
        background-color: #f6f9fc;
        // padding-top: 10px;
        /deep/ .swiper-container {
            height: 100%;
        }
        .card-item {
            padding: 10px;
        }
    }

    .use-card-list {
        width: 100%;
        height: 200px;
    }
</style>